// AUTO-GENERATED — do not edit manually.
// Add photos to public/assets/scroll/ and run: npm run generate:scroll

export const SCROLL_PHOTOS = [
  "/assets/scroll/7010naoto-nature-9715206_1920 copy 2.jpg"
];
